import "../styles/index.css";
import "../scss/main.scss";

import "@hotwired/turbo";
import "../scripts/popstate_handler";
import { sessionExpired } from "../scripts/session_expired";
import { Application } from "@hotwired/stimulus";
import TabsController from "../controllers/tabs_controller";
import SearchController from "../controllers/search_controller";
import ListGridViewToggleController from "../controllers/list_grid_view_toggle_controller";
import NavigationController from "../controllers/navigation_controller";
import CheckboxController from "../controllers/checkbox_controller"
import RangeController from "../controllers/range_controller"
import YearRangeController from "../controllers/year_range_controller"
import CareerSearchToolController from "../controllers/career_search_tool_controller"
import ScrollTriggerController from '../controllers/scroll_trigger_controller';
import OneItemSwiperController from '../controllers/one_item_swiper_controller';
import TwoItemsSwiperController from '../controllers/two_items_swiper_controller';
import SidebarScrollController from '../controllers/sidebar_scroll_controller';
import DropdownController from '../controllers/dropdown_controller';
import Tooltip from '../controllers/tooltip_controller';
import StudyAreaModalController from '../controllers/study_area_modal_controller';
import StudyAreaSliderController from '../controllers/study_area_slider_controller';
import SidebarNavController from '../controllers/sidebar_nav_controller';
import BackToTopController from '../controllers/back_to_top_controller';
import TextImageController from '../controllers/text_image_controller';
import MobileDropdownController from '../controllers/mobile_dropdown_controller';
import ChameleonController from '../controllers/chameleon_controller';
import AccordionController from '../controllers/accordion_controller';
import CookieyesController from '../controllers/cookieyes_controller';
import LoginController from '../controllers/login_controller';
import SelectController from '../controllers/select_controller';
import CancelWarningController from '../controllers/cancel_warning_controller';
import ActiveLinksController from '../controllers/active_links_controller';
import EditProfileController from "../controllers/edit_profile_controller";
import AddToListController from '../controllers/add_to_list_controller';
import ToastController from "../controllers/toast_controller";
import AccountSettingsController from "../controllers/account_settings_controller";
import AppSwitcherController from '../controllers/app_switcher_controller';
import FormValidationController from '../controllers/form_validation_controller';

import { initFlowbite } from "flowbite";

window.Stimulus = Application.start();

window.Stimulus.register("tabs", TabsController);
window.Stimulus.register("listGridViewToggle", ListGridViewToggleController);
window.Stimulus.register("navigation", NavigationController);
window.Stimulus.register("checkbox", CheckboxController);
window.Stimulus.register("range", RangeController);
window.Stimulus.register("yearRange", YearRangeController);
window.Stimulus.register("careerSearchTool", CareerSearchToolController);
window.Stimulus.register("scrollTrigger", ScrollTriggerController);
window.Stimulus.register("search", SearchController);
window.Stimulus.register("oneItemSwiper", OneItemSwiperController);
window.Stimulus.register("twoItemsSwiper", TwoItemsSwiperController);
window.Stimulus.register("sidebarScroll", SidebarScrollController);
window.Stimulus.register("dropdown", DropdownController);
window.Stimulus.register("tooltip", Tooltip);
window.Stimulus.register("study-area-modal", StudyAreaModalController);
window.Stimulus.register("study-area-slider", StudyAreaSliderController);
window.Stimulus.register("sidebar-nav", SidebarNavController);
window.Stimulus.register("backToTop", BackToTopController);
window.Stimulus.register("text-image", TextImageController);
window.Stimulus.register("mobile-dropdown", MobileDropdownController);
window.Stimulus.register("chameleon", ChameleonController);
window.Stimulus.register("accordion", AccordionController);
window.Stimulus.register("login", LoginController);
window.Stimulus.register("select", SelectController);
window.Stimulus.register("cancel-warning", CancelWarningController);
window.Stimulus.register("cookieyes", CookieyesController);
window.Stimulus.register("active-links", ActiveLinksController);
window.Stimulus.register("edit-profile", EditProfileController);
window.Stimulus.register("add-to-list", AddToListController);
window.Stimulus.register("toast", ToastController);
window.Stimulus.register("account-settings", AccountSettingsController);
window.Stimulus.register("app-switcher", AppSwitcherController);
window.Stimulus.register("form-validation", FormValidationController);

document.addEventListener('turbo:load', function () {
  initFlowbite();
  sessionExpired();
});